// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"681671d7","230":"dd6515c1","368":"f728bcb0","956":"8d4e5d92","961":"2f5ebd48"}[chunkId] + ".chunk.js";
};